import PropTypes from 'prop-types'
import { PureComponent } from 'react'

import { ANIMATE_FROM, AnimatedList } from 'ui'

import NotificationSchema from '../../schemas/NotificationSchema'
import Notification from '../Notification'

class NotificationsContainer extends PureComponent {
  onClick = (notification, event) => {
    if (notification.onClick) {
      notification.onClick(event)
    }
    this.props.onRemoveNotification(notification)
  }

  onClose = (notification, event) => {
    if (notification.onClose) {
      notification.onClose(event)
    }
    this.props.onRemoveNotification(notification)
  }

  onDismiss = (notification) => {
    if (notification.onDismiss) {
      notification.onDismiss()
    }
    this.props.onRemoveNotification(notification)
  }

  render() {
    const { className, initialDelay, notifications } = this.props
    return (
      <div className={className}>
        <AnimatedList animateFrom={ANIMATE_FROM.RIGHT} initialDelay={initialDelay} unmountOnExit>
          {notifications.map((notification) => (
            <Notification
              {...notification}
              key={notification.id}
              className={notification.className}
              onClick={(event) => this.onClick(notification, event)}
              onClose={(event) => this.onClose(notification, event)}
              onDismiss={() => this.onDismiss(notification)}
            />
          ))}
        </AnimatedList>
      </div>
    )
  }
}

NotificationsContainer.propTypes = {
  notifications: PropTypes.arrayOf(NotificationSchema).isRequired,

  className: PropTypes.string,
  initialDelay: PropTypes.number,
  onRemoveNotification: PropTypes.func,
}

NotificationsContainer.defaultProps = {
  className: null,
  initialDelay: 200,
  onRemoveNotification: Function.prototype,
}

export default NotificationsContainer
